(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;
      this.isAtTop = false;

      this.suppressScrollUntil = 0;
      this.toggleBtn = this.querySelector('header-menu-toggle');
      this.toggleBtn?.addEventListener('click', () => {
        this.suppressScrollUntil = performance.now() + 250;
        this.header.classList.toggle('shopify-section-header-menu-open');
      });

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.disconnectedCallback?.();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      if (performance.now() < this.suppressScrollUntil) {
        this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
        return;
      }

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop <= 0) {
        this.header.classList.remove('shopify-section-header-sticky');
        document.body.classList.remove('shopify-body-section-header-sticky');
        this.isAtTop = true;
        this.currentScrollTop = scrollTop;
        return;
      }
      if (this.isAtTop && scrollTop > 10) {
        this.isAtTop = false;
      }
      if (this.isAtTop) {
        this.currentScrollTop = scrollTop;
        return;
      }

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 300);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    reveal() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden') && document.body.classList.contains('shopify-body-section-header-sticky') && !document.body.classList.contains('shopify-body-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["order-tracking"] && !Shopify.designMode) return;
  try {
    
  class OrderTracking extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.message = this.querySelector('.order-tracking__message');
      this.result = this.querySelector('.order-tracking__result');

      if (this.form) {
        this.form.addEventListener('submit', this.onSubmit.bind(this));
      }
    }

    async onSubmit(event) {
      event.preventDefault();

      const endpoint = this.dataset.endpoint;
      const formData = new FormData(this.form);
      const orderNumber = String(formData.get('order_number') || '').trim();
      const email = String(formData.get('email') || '').trim();

      this.clearResult();

      if (!endpoint) {
        this.showMessage(this.dataset.endpointMissing, true);
        return;
      }

      if (!orderNumber || !email) {
        this.showMessage(this.dataset.error, true);
        return;
      }

      this.setBusy(true);
      this.showMessage(this.dataset.loading, false);

      try {
        const response = await fetch(endpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            order_number: orderNumber,
            email: email
          })
        });

        const responseText = await response.text();
        let payload;

        try {
          payload = responseText ? JSON.parse(responseText) : {};
        } catch (parseError) {
          throw new Error(this.dataset.error);
        }

        if (!response.ok || payload.error) {
          throw new Error(payload.message || this.dataset.error);
        }

        if (!Object.keys(payload).length) {
          throw new Error(this.dataset.error);
        }

        if (payload.found === false) {
          this.showMessage(payload.message || this.dataset.notFound, true);
          return;
        }

        this.hideMessage();
        this.renderResult(payload);
      } catch (error) {
        this.showMessage(error.message || this.dataset.error, true);
      } finally {
        this.setBusy(false);
      }
    }

    setBusy(isBusy) {
      const button = this.querySelector('button[type="submit"]');

      if (button) {
        button.classList.toggle('loading', isBusy);
        button.disabled = isBusy;
      }
    }

    showMessage(text, isError) {
      this.message.textContent = text;
      this.message.classList.toggle('order-tracking__message--error', isError);
      this.message.hidden = false;
    }

    hideMessage() {
      this.message.hidden = true;
      this.message.textContent = '';
      this.message.classList.remove('order-tracking__message--error');
    }

    clearResult() {
      this.result.hidden = true;
      this.result.replaceChildren();
    }

    renderResult(payload) {
      const order = payload.order || payload;
      const trackingItems = this.getTrackingItems(order, payload);
      const title = this.createElement('h2', 'order-tracking__result-title', this.dataset.resultTitle);
      const summary = document.createElement('dl');
      summary.className = 'order-tracking__summary';

      this.addSummaryItem(summary, this.dataset.orderLabel, order.name || order.order_name || order.order_number || payload.order_number);
      this.addSummaryItem(summary, this.dataset.statusLabel, order.fulfillment_status || order.status || payload.status);
      this.addSummaryItem(summary, this.dataset.dateLabel, order.created_at || order.processed_at || payload.created_at);

      this.result.append(title, summary);

      if (trackingItems.length > 0) {
        const list = document.createElement('ul');
        list.className = 'order-tracking__shipments list-unstyled';

        trackingItems.forEach((item) => {
          const listItem = document.createElement('li');
          listItem.className = 'order-tracking__shipment';
          const details = document.createElement('dl');
          details.className = 'order-tracking__shipment-details';

          const url = item.url || item.tracking_url;
          const trackingNumber = item.number || item.tracking_number;

          this.addSummaryItem(details, this.dataset.carrierLabel, item.company || item.tracking_company || item.carrier);
          this.addTrackingNumberItem(details, this.dataset.trackingNumberLabel, trackingNumber, url);
          listItem.append(details);

          if (url) {
            const link = document.createElement('a');
            link.className = 'button button--small button--cta order-tracking__track-button';
            link.href = url;
            link.target = '_blank';
            link.rel = 'noopener noreferrer';
            link.textContent = this.dataset.trackLabel;
            listItem.append(link);
          }

          list.append(listItem);
        });

        this.result.append(list);
      } else {
        this.result.append(this.createElement('p', 'order-tracking__empty', this.dataset.noTracking));
      }

      this.result.hidden = false;
    }

    getTrackingItems(order, payload) {
      if (Array.isArray(payload.tracking)) {
        return payload.tracking;
      }

      if (Array.isArray(order.tracking)) {
        return order.tracking;
      }

      if (Array.isArray(order.fulfillments)) {
        return order.fulfillments.flatMap((fulfillment) => {
          if (Array.isArray(fulfillment.tracking_info)) {
            return fulfillment.tracking_info;
          }

          if (fulfillment.tracking_number || fulfillment.tracking_url) {
            return [fulfillment];
          }

          return [];
        });
      }

      if (order.tracking_number || order.tracking_url) {
        return [order];
      }

      return [];
    }

    addSummaryItem(list, label, value) {
      if (!value) {
        return;
      }

      const term = document.createElement('dt');
      const description = document.createElement('dd');

      term.textContent = label;
      description.textContent = value;
      list.append(term, description);
    }

    addTrackingNumberItem(list, label, value, url) {
      if (!value) {
        return;
      }

      const term = document.createElement('dt');
      const description = document.createElement('dd');

      term.textContent = label;

      if (url) {
        const link = document.createElement('a');
        link.className = 'order-tracking__tracking-link';
        link.href = url;
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
        link.textContent = value;
        description.append(link);
      } else {
        description.textContent = value;
      }

      list.append(term, description);
    }

    createElement(tagName, className, text) {
      const element = document.createElement(tagName);
      element.className = className;
      element.textContent = text;
      return element;
    }
  }

  customElements.define('order-tracking', OrderTracking);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-metafield-gallery"] && !Shopify.designMode) return;
  try {
    
  class ProductMetafieldGallery extends HTMLElement {
    connectedCallback() {
      this.moreButton = this.querySelector('[data-product-metafield-more]');
      this.moreText = this.querySelector('[data-product-metafield-more-text]');
      this.tabs = this.querySelectorAll('[data-product-metafield-tab]');
      this.panels = this.querySelectorAll('[data-product-metafield-panel]');

      if (this.moreButton) {
        this.moreButton.addEventListener('click', this.toggleExpand.bind(this));
      }

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.selectTab(tab));
      });
    }

    toggleExpand() {
      const isExpanded = this.classList.toggle('is-expanded');
      this.moreButton.setAttribute('aria-expanded', String(isExpanded));

      if (this.moreText) {
        this.moreText.textContent = isExpanded ? this.dataset.lessLabel : this.dataset.moreLabel;
      }
    }

    selectTab(selectedTab) {
      const panelId = selectedTab.getAttribute('aria-controls');

      this.tabs.forEach((tab) => {
        const isSelected = tab === selectedTab;
        tab.classList.toggle('is-active', isSelected);
        tab.setAttribute('aria-selected', String(isSelected));
      });

      this.panels.forEach((panel) => {
        panel.classList.toggle('hidden', panel.id !== panelId);
      });
    }
  }

  if (!customElements.get('product-metafield-gallery')) {
    customElements.define('product-metafield-gallery', ProductMetafieldGallery);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-recommendation"] && !Shopify.designMode) return;
  try {
    
  class StickyRecommendation extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.shopify-section-sticky-recommendation');
      this.header = document.querySelector('.shopify-section-header');
      this.links = this.querySelector('.sticky-recommendation');
      if (!this.section || !this.header || !this.links) return;

      this.mobileQuery = window.matchMedia('(max-width: 749px)');
      this.repositionAfterFirstSlideshow = this.repositionAfterFirstSlideshow.bind(this);
      this.update = this.update.bind(this);
      this.repositionAfterFirstSlideshow();
      this.update();

      window.addEventListener('resize', this.update);
      window.addEventListener('scroll', this.update, { passive: true });
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.update);
      window.removeEventListener('scroll', this.update);
      document.documentElement.style.removeProperty('--sticky-recommendation-height');
    }

    repositionAfterFirstSlideshow() {
      if (!this.mobileQuery.matches || !this.header.querySelector('.header-transparent')) return;

      const slideshow = document.querySelector('#MainContent .slideshow');
      const slideshowSection = slideshow && slideshow.closest('.shopify-section');
      if (!slideshowSection || this.section.previousElementSibling === slideshowSection) return;

      slideshowSection.insertAdjacentElement('afterend', this.section);
    }

    update() {
      if (!this.header) return;

      this.repositionAfterFirstSlideshow();

      const headerIsVisible = this.mobileQuery.matches
        && this.header.classList.contains('shopify-section-header-sticky')
        && !this.header.classList.contains('shopify-section-header-hidden');
      const offset = headerIsVisible ? this.header.getBoundingClientRect().height : 0;
      this.section.style.setProperty('--sticky-recommendation-top', `${offset}px`);
      document.documentElement.style.setProperty(
        '--sticky-recommendation-height',
        `${this.mobileQuery.matches ? this.links.getBoundingClientRect().height : 0}px`
      );
      this.links.classList.toggle('sticky-recommendation--scrollable', this.links.scrollWidth > this.links.clientWidth + 1);
    }
  }

  if (!customElements.get('sticky-recommendation')) {
    customElements.define('sticky-recommendation', StickyRecommendation);
  }

  } catch(e) { console.error(e); }
})();
})();
